import { HeroBannerWrapper, HeroBannerContainer, HeroBannerTitle, HeroBannerHighlight, HeroBannerImage } from './styles/components';

export default function HeroBanner() {
  return (
    <HeroBannerWrapper>
      <HeroBannerContainer>
        <HeroBannerTitle>
          <HeroBannerHighlight>
            Switch & Save
          </HeroBannerHighlight>
          <br />
          with Constellation
        </HeroBannerTitle>

        <HeroBannerImage
          src="/images/constenewImg/img-home-desktop-min.png"
          alt=""
        />
      </HeroBannerContainer>
    </HeroBannerWrapper>
  );
}